import React from 'react';
import { Elements } from 'react-stripe-elements';

const StripeElementsWrapper = ({ children }) => <Elements>{children}</Elements>;

export default StripeElementsWrapper;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/StripeElementsWrapper.jsx